import React, { useState } from "react";

import ModalFichaTecnica from "../ModalFichaTecnica/ModalFichaTecnica";

export const MainContent = ({handleShowProp}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="contenedorDosBotones">
      <button className="btn-quiero-conocerlo outline " onClick={handleShow}>
        Ver ficha técnica
      </button>
      <button className="btn-quiero-conocerlo" onClick={handleShowProp}>
        Consultar
      </button>

      <ModalFichaTecnica show={show} handleClose={handleClose} />
    </div>
  );
};
